import React from 'react';
import PropTypes from 'prop-types';
const Timer = ({ time, setTimesOut, setTime }) => {

  const timeStyle = {
    fontFamily: 'Mukta',
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '700',
    color: '#054E8B'
  };

  React.useEffect(() => {
    if (time === 0) setTimesOut(true);
    if (time > 0) {
      setTimeout(() => {
        setTime(time - 1000);
      }, 1000);
    }
  }, [time]);
  const formatStr = (str) =>
    String(str).length == 2 ? String(str) : `0${str}`;

  const getFormattedTime = () => {
    const totalSeconds = parseInt(Math.floor(time / 1000));
    const totalMins = parseInt(Math.floor(totalSeconds / 60));
    const totalHours = parseInt(Math.floor(totalMins / 60));
    const totalDays = parseInt(Math.floor(totalHours / 24));
    const seconds = parseInt(totalSeconds % 60);
    const mins = parseInt(totalMins % 60);
    const hrs = parseInt(totalHours % 24);
    return totalDays > 0
      ? `${formatStr(totalDays)}:${formatStr(hrs)}:${formatStr(
          mins
        )}:${formatStr(seconds)}`
      : totalHours > 0
      ? `${formatStr(hrs)}:${formatStr(mins)}:${formatStr(seconds)}`
      : `${formatStr(mins)}:${formatStr(seconds)}`;
  };
  return (
    time > 0 && <div style= {timeStyle}>{getFormattedTime()}</div>
  );
};
Timer.propTypes = {
  time: PropTypes.number,
  setTime: PropTypes.func,
  setTimesOut: PropTypes.func,
};
export default Timer;
